import { createReducer } from '@reduxjs/toolkit';

import { FETCH_ENTITY_SUCCESS } from 'modules/entity/actionTypes';

import * as actionTypes from '../../actionTypes';

/** @typedef {boolean} IsRefreshPageModalOpenState */

/** @type {IsRefreshPageModalOpenState} */
const initialState = false;

const open = () => true;
const close = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(actionTypes.OPEN_REFRESH_PAGE_MODAL, open)
    .addCase(FETCH_ENTITY_SUCCESS, close);
});
